export const permissionActions = ["view", "create", "edit", "delete"] as const;
export type PermissionAction = (typeof permissionActions)[number];

export const permissionModules = [
  "dashboard",
  "ai_apps",
  "review_queue",
  "agent_inventory",
  "findings",
  "evaluators",
  "projects",
  "audit_explorer",
  "model_cards",
  "workflow_builder",
  "discovery",
  "baa_preflight",
  "conversations",
  "tenant_admin",
  "integrations",
  "assurance",
  "subscription",
  "settings",
  "role_access",
] as const;
export type PermissionModule = (typeof permissionModules)[number];

export const allPermissionKeys = permissionModules.flatMap((module) =>
  permissionActions.map((action) => `${module}:${action}`),
);

export interface PermissionAwareUser {
  role: string;
  permissions?: readonly string[] | null;
}

export function permissionKey(
  module: PermissionModule,
  action: PermissionAction,
): string {
  return `${module}:${action}`;
}

/**
 * Frontend visibility check only. The backend remains the authorization
 * authority; this helper prevents controls from being shown when the current
 * user's effective grant set says they cannot use them.
 */
export function hasPermission(
  user: PermissionAwareUser | null | undefined,
  module: PermissionModule,
  action: PermissionAction,
): boolean {
  if (!user) return false;
  if (user.role === "tenant_owner") return true;
  return user.permissions?.includes(permissionKey(module, action)) ?? false;
}
